// Cuisine visual metadata. Full Tailwind class strings are written literally so
// they are detected by the Tailwind compiler (no dynamic string building).

export const CUISINE_META = {
  indian: {
    key: "indian",
    name: "Indian",
    dot: "bg-amber-500",
    badge: "bg-amber-100 text-amber-800",
    text: "text-amber-700",
    sectionBg: "bg-amber-50",
    border: "border-amber-200",
    ring: "focus-visible:ring-amber-500",
    barFrom: "from-amber-400",
  },
  italian: {
    key: "italian",
    name: "Italian",
    dot: "bg-green-500",
    badge: "bg-green-100 text-green-800",
    text: "text-green-700",
    sectionBg: "bg-green-50",
    border: "border-green-200",
    ring: "focus-visible:ring-green-500",
    barFrom: "from-green-400",
  },
  chinese: {
    key: "chinese",
    name: "Chinese",
    dot: "bg-red-500",
    badge: "bg-red-100 text-red-800",
    text: "text-red-700",
    sectionBg: "bg-red-50",
    border: "border-red-200",
    ring: "focus-visible:ring-red-500",
    barFrom: "from-red-400",
  },
  mexican: {
    key: "mexican",
    name: "Mexican",
    dot: "bg-pink-500",
    badge: "bg-pink-100 text-pink-800",
    text: "text-pink-700",
    sectionBg: "bg-pink-50",
    border: "border-pink-200",
    ring: "focus-visible:ring-pink-500",
    barFrom: "from-pink-400",
  },
  pet: {
    key: "pet",
    name: "Pet-Friendly",
    dot: "bg-sky-500",
    badge: "bg-sky-100 text-sky-800",
    text: "text-sky-700",
    sectionBg: "bg-sky-50",
    border: "border-sky-200",
    ring: "focus-visible:ring-sky-500",
    barFrom: "from-sky-400",
  },
};

export const CUISINE_ORDER = ["indian", "italian", "chinese", "mexican"];

export const metaFor = (key) => CUISINE_META[key] || CUISINE_META.indian;
